import { get, isNil } from 'lodash';

const getAny = (defaultValue, path, root) => {
  const found = get(root, path);
  return isNil(found) ? defaultValue : found;
};

// noinspection JSUnusedGlobalSymbols
export default getAny;
